import styled from 'styled-components';

export const Container = styled.div`
  height: 150px;

  .left {
    width: 70%;
    box-sizing: border-box;
    padding: 30px 30px;
    white-space: nowrap;
  }

  .right {
    width: 30%;
    display: flex;
    justify-content: center;
    align-items: center;

    .containerIcon {
      font-size: 50px;
      color: white;
      padding-left: 8px;
    }
  }

  .cardContainer {
    padding-right: 0px;
    padding-left: 0px;
    height: 160px;
  }

  .card-footer {
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;

    svg {
      margin-left: 5px;
    }
  }

  .text-muted {
    cursor: pointer;
    background-color: rgba(0, 0, 0, 0.1);
    border: 1px solid rgba(0, 0, 0, 0.125);

    &:hover {
      color: #fff !important;
      background: rgba(0, 0, 0, 0.15) !important;
    }
    color: rgba(255, 255, 255, 0.8) !important;
  }

  .footerDisabled {
    cursor: pointer;
    background-color: rgba(0, 0, 0, 0);
    border: 0px;
  }
`;

interface Props {
  titleLength: number;
}

export const StyledCardTitle = styled.h5<Props>`
  font-size: ${({ titleLength }) => {
    const minSize = 0.72;
    const maxSize = 1.15;
    const maxLength = 10;
    const ideal = maxSize - (titleLength - maxLength) * 0.05;
    return `clamp(${minSize}rem, ${ideal}rem, ${maxSize}rem)`;
  }};
`;
